var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path0, _path1, _path10, _path11, _path12, _g2, _g3, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g4, _g5, _g6, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1371 64.8739C18.7069 64.8739 20.7901 62.7906 20.7901 60.2209C20.7901 57.6511 18.7069 55.5679 16.1371 55.5679C13.5674 55.5679 11.4841 57.6511 11.4841 60.2209C11.4841 62.7906 13.5674 64.8739 16.1371 64.8739Z",
    fill: "url(#paint0_radial_475_12217)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8991 64.91C82.4689 64.91 84.5521 62.8268 84.5521 60.257C84.5521 57.6872 82.4689 55.604 79.8991 55.604C77.3293 55.604 75.2461 57.6872 75.2461 60.257C75.2461 62.8268 77.3293 64.91 79.8991 64.91Z",
    fill: "url(#paint1_radial_475_12217)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8991 64.91C82.4689 64.91 84.5521 62.8268 84.5521 60.257C84.5521 57.6872 82.4689 55.604 79.8991 55.604C77.3293 55.604 75.2461 57.6872 75.2461 60.257C75.2461 62.8268 77.3293 64.91 79.8991 64.91Z",
    fill: "url(#paint2_radial_475_12217)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0242 29.717C25.2242 32.417 23.9132 36.092 23.4602 37.499L30.4922 42.56L35.8622 35.762C34.9038 34.3082 33.9033 32.8826 32.8622 31.487C32.0159 30.4246 31.1147 29.4073 30.1622 28.439L27.0242 29.717Z",
    fill: "url(#paint3_radial_475_12217)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0242 29.717C25.2242 32.417 23.9132 36.092 23.4602 37.499L30.4922 42.56L35.8622 35.762C34.9038 34.3082 33.9033 32.8826 32.8622 31.487C32.0159 30.4246 31.1147 29.4073 30.1622 28.439L27.0242 29.717Z",
    fill: "url(#paint4_radial_475_12217)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9762 29.717C70.7762 32.417 72.0872 36.092 72.5402 37.499L65.5082 42.56L60.1382 35.762C60.7742 34.787 62.2772 32.612 63.1382 31.487C63.9992 30.362 65.3042 28.985 65.8382 28.439L68.9762 29.717Z",
    fill: "url(#paint5_radial_475_12217)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9762 29.717C70.7762 32.417 72.0872 36.092 72.5402 37.499L65.5082 42.56L60.1382 35.762C60.7742 34.787 62.2772 32.612 63.1382 31.487C63.9992 30.362 65.3042 28.985 65.8382 28.439L68.9762 29.717Z",
    fill: "url(#paint6_radial_475_12217)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9762 29.717C70.7762 32.417 72.0872 36.092 72.5402 37.499L65.5082 42.56L60.1382 35.762C60.7742 34.787 62.2772 32.612 63.1382 31.487C63.9992 30.362 65.3042 28.985 65.8382 28.439L68.9762 29.717Z",
    fill: "url(#paint7_radial_475_12217)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_475_12217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.375 29.9269L18.693 75.4039C18.9156 76.4875 19.5057 77.4609 20.3634 78.1595C21.2211 78.8581 22.2938 79.2391 23.4 79.2379H72.6C73.7066 79.2381 74.7792 78.856 75.6364 78.1562C76.4936 77.4565 77.0827 76.4821 77.304 75.3979L86.622 29.9239L83.646 28.4719C79.194 31.7059 69.87 38.3389 67.464 39.7909C65.544 40.9489 63.78 39.0619 63.414 38.5249C60.063 33.6049 54.948 26.4409 53.034 23.9239C51.078 21.3439 48.864 20.0719 47.997 19.9639C47.13 20.0719 44.916 21.3439 42.957 23.9239C41.046 26.4409 35.934 33.6049 32.58 38.5249C32.214 39.0619 30.45 40.9519 28.53 39.7909C26.124 38.3389 16.8 31.7059 12.348 28.4719L9.375 29.9269Z",
    fill: "url(#paint8_linear_475_12217)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 29.9269L18.693 75.4039C18.9156 76.4875 19.5057 77.4609 20.3634 78.1595C21.2211 78.8581 22.2938 79.2391 23.4 79.2379H72.6C73.7066 79.2381 74.7792 78.856 75.6364 78.1562C76.4936 77.4565 77.0827 76.4821 77.304 75.3979L86.622 29.9239L83.646 28.4719C79.194 31.7059 69.87 38.3389 67.464 39.7909C65.544 40.9489 63.78 39.0619 63.414 38.5249C60.063 33.6049 54.948 26.4409 53.034 23.9239C51.078 21.3439 48.864 20.0719 47.997 19.9639C47.13 20.0719 44.916 21.3439 42.957 23.9239C41.046 26.4409 35.934 33.6049 32.58 38.5249C32.214 39.0619 30.45 40.9519 28.53 39.7909C26.124 38.3389 16.8 31.7059 12.348 28.4719L9.375 29.9269Z",
    fill: "url(#paint9_radial_475_12217)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 29.9269L18.693 75.4039C18.9156 76.4875 19.5057 77.4609 20.3634 78.1595C21.2211 78.8581 22.2938 79.2391 23.4 79.2379H72.6C73.7066 79.2381 74.7792 78.856 75.6364 78.1562C76.4936 77.4565 77.0827 76.4821 77.304 75.3979L86.622 29.9239L83.646 28.4719C79.194 31.7059 69.87 38.3389 67.464 39.7909C65.544 40.9489 63.78 39.0619 63.414 38.5249C60.063 33.6049 54.948 26.4409 53.034 23.9239C51.078 21.3439 48.864 20.0719 47.997 19.9639C47.13 20.0719 44.916 21.3439 42.957 23.9239C41.046 26.4409 35.934 33.6049 32.58 38.5249C32.214 39.0619 30.45 40.9519 28.53 39.7909C26.124 38.3389 16.8 31.7059 12.348 28.4719L9.375 29.9269Z",
    fill: "url(#paint10_linear_475_12217)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 29.9269L18.693 75.4039C18.9156 76.4875 19.5057 77.4609 20.3634 78.1595C21.2211 78.8581 22.2938 79.2391 23.4 79.2379H72.6C73.7066 79.2381 74.7792 78.856 75.6364 78.1562C76.4936 77.4565 77.0827 76.4821 77.304 75.3979L86.622 29.9239L83.646 28.4719C79.194 31.7059 69.87 38.3389 67.464 39.7909C65.544 40.9489 63.78 39.0619 63.414 38.5249C60.063 33.6049 54.948 26.4409 53.034 23.9239C51.078 21.3439 48.864 20.0719 47.997 19.9639C47.13 20.0719 44.916 21.3439 42.957 23.9239C41.046 26.4409 35.934 33.6049 32.58 38.5249C32.214 39.0619 30.45 40.9519 28.53 39.7909C26.124 38.3389 16.8 31.7059 12.348 28.4719L9.375 29.9269Z",
    fill: "url(#paint11_linear_475_12217)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 29.9269L18.693 75.4039C18.9156 76.4875 19.5057 77.4609 20.3634 78.1595C21.2211 78.8581 22.2938 79.2391 23.4 79.2379H72.6C73.7066 79.2381 74.7792 78.856 75.6364 78.1562C76.4936 77.4565 77.0827 76.4821 77.304 75.3979L86.622 29.9239L83.646 28.4719C79.194 31.7059 69.87 38.3389 67.464 39.7909C65.544 40.9489 63.78 39.0619 63.414 38.5249C60.063 33.6049 54.948 26.4409 53.034 23.9239C51.078 21.3439 48.864 20.0719 47.997 19.9639C47.13 20.0719 44.916 21.3439 42.957 23.9239C41.046 26.4409 35.934 33.6049 32.58 38.5249C32.214 39.0619 30.45 40.9519 28.53 39.7909C26.124 38.3389 16.8 31.7059 12.348 28.4719L9.375 29.9269Z",
    fill: "url(#paint12_linear_475_12217)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 29.9269L18.693 75.4039C18.9156 76.4875 19.5057 77.4609 20.3634 78.1595C21.2211 78.8581 22.2938 79.2391 23.4 79.2379H72.6C73.7066 79.2381 74.7792 78.856 75.6364 78.1562C76.4936 77.4565 77.0827 76.4821 77.304 75.3979L86.622 29.9239L83.646 28.4719C79.194 31.7059 69.87 38.3389 67.464 39.7909C65.544 40.9489 63.78 39.0619 63.414 38.5249C60.063 33.6049 54.948 26.4409 53.034 23.9239C51.078 21.3439 48.864 20.0719 47.997 19.9639C47.13 20.0719 44.916 21.3439 42.957 23.9239C41.046 26.4409 35.934 33.6049 32.58 38.5249C32.214 39.0619 30.45 40.9519 28.53 39.7909C26.124 38.3389 16.8 31.7059 12.348 28.4719L9.375 29.9269Z",
    fill: "url(#paint13_radial_475_12217)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 29.9269L18.693 75.4039C18.9156 76.4875 19.5057 77.4609 20.3634 78.1595C21.2211 78.8581 22.2938 79.2391 23.4 79.2379H72.6C73.7066 79.2381 74.7792 78.856 75.6364 78.1562C76.4936 77.4565 77.0827 76.4821 77.304 75.3979L86.622 29.9239L83.646 28.4719C79.194 31.7059 69.87 38.3389 67.464 39.7909C65.544 40.9489 63.78 39.0619 63.414 38.5249C60.063 33.6049 54.948 26.4409 53.034 23.9239C51.078 21.3439 48.864 20.0719 47.997 19.9639C47.13 20.0719 44.916 21.3439 42.957 23.9239C41.046 26.4409 35.934 33.6049 32.58 38.5249C32.214 39.0619 30.45 40.9519 28.53 39.7909C26.124 38.3389 16.8 31.7059 12.348 28.4719L9.375 29.9269Z",
    fill: "url(#paint14_radial_475_12217)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 29.9269L18.693 75.4039C18.9156 76.4875 19.5057 77.4609 20.3634 78.1595C21.2211 78.8581 22.2938 79.2391 23.4 79.2379H72.6C73.7066 79.2381 74.7792 78.856 75.6364 78.1562C76.4936 77.4565 77.0827 76.4821 77.304 75.3979L86.622 29.9239L83.646 28.4719C79.194 31.7059 69.87 38.3389 67.464 39.7909C65.544 40.9489 63.78 39.0619 63.414 38.5249C60.063 33.6049 54.948 26.4409 53.034 23.9239C51.078 21.3439 48.864 20.0719 47.997 19.9639C47.13 20.0719 44.916 21.3439 42.957 23.9239C41.046 26.4409 35.934 33.6049 32.58 38.5249C32.214 39.0619 30.45 40.9519 28.53 39.7909C26.124 38.3389 16.8 31.7059 12.348 28.4719L9.375 29.9269Z",
    fill: "url(#paint15_radial_475_12217)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_475_12217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.3402 61.6971C70.5422 64.1391 67.9862 65.3631 65.5442 64.5681C63.7022 63.8181 62.9072 61.7151 63.7022 59.2731C64.4972 56.8281 67.0022 55.4271 68.5202 55.9191C70.9622 56.7141 72.1322 59.2521 71.3402 61.6971Z",
    fill: "url(#paint16_radial_475_12217)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3402 61.6971C70.5422 64.1391 67.9862 65.3631 65.5442 64.5681C63.7022 63.8181 62.9072 61.7151 63.7022 59.2731C64.4972 56.8281 67.0022 55.4271 68.5202 55.9191C70.9622 56.7141 72.1322 59.2521 71.3402 61.6971Z",
    fill: "url(#paint17_radial_475_12217)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_475_12217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8911 61.6971C25.6861 64.1391 28.2421 65.3631 30.6871 64.5681C32.5261 63.8181 33.3211 61.7151 32.5261 59.2731C31.7311 56.8281 29.2261 55.4271 27.7111 55.9191C25.2661 56.7141 24.0961 59.2521 24.8911 61.6971Z",
    fill: "url(#paint18_radial_475_12217)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8911 61.6971C25.6861 64.1391 28.2421 65.3631 30.6871 64.5681C32.5261 63.8181 33.3211 61.7151 32.5261 59.2731C31.7311 56.8281 29.2261 55.4271 27.7111 55.9191C25.2661 56.7141 24.0961 59.2521 24.8911 61.6971Z",
    fill: "url(#paint19_radial_475_12217)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7661 29.2432C14.7661 30.3496 14.3266 31.4106 13.5443 32.1929C12.762 32.9752 11.7009 33.4147 10.5946 33.4147C9.48825 33.4147 8.42721 32.9752 7.6449 32.1929C6.86259 31.4106 6.4231 30.3496 6.4231 29.2432C6.4231 28.1373 6.86243 27.0766 7.64446 26.2946C8.42649 25.5126 9.48714 25.0732 10.5931 25.0732C11.699 25.0732 12.7597 25.5126 13.5417 26.2946C14.3238 27.0766 14.7661 28.1373 14.7661 29.2432Z",
    fill: "url(#paint20_radial_475_12217)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7661 29.2432C14.7661 30.3496 14.3266 31.4106 13.5443 32.1929C12.762 32.9752 11.7009 33.4147 10.5946 33.4147C9.48825 33.4147 8.42721 32.9752 7.6449 32.1929C6.86259 31.4106 6.4231 30.3496 6.4231 29.2432C6.4231 28.1373 6.86243 27.0766 7.64446 26.2946C8.42649 25.5126 9.48714 25.0732 10.5931 25.0732C11.699 25.0732 12.7597 25.5126 13.5417 26.2946C14.3238 27.0766 14.7661 28.1373 14.7661 29.2432Z",
    fill: "url(#paint21_radial_475_12217)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7661 29.2432C14.7661 30.3496 14.3266 31.4106 13.5443 32.1929C12.762 32.9752 11.7009 33.4147 10.5946 33.4147C9.48825 33.4147 8.42721 32.9752 7.6449 32.1929C6.86259 31.4106 6.4231 30.3496 6.4231 29.2432C6.4231 28.1373 6.86243 27.0766 7.64446 26.2946C8.42649 25.5126 9.48714 25.0732 10.5931 25.0732C11.699 25.0732 12.7597 25.5126 13.5417 26.2946C14.3238 27.0766 14.7661 28.1373 14.7661 29.2432Z",
    fill: "url(#paint22_radial_475_12217)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7661 29.2432C14.7661 30.3496 14.3266 31.4106 13.5443 32.1929C12.762 32.9752 11.7009 33.4147 10.5946 33.4147C9.48825 33.4147 8.42721 32.9752 7.6449 32.1929C6.86259 31.4106 6.4231 30.3496 6.4231 29.2432C6.4231 28.1373 6.86243 27.0766 7.64446 26.2946C8.42649 25.5126 9.48714 25.0732 10.5931 25.0732C11.699 25.0732 12.7597 25.5126 13.5417 26.2946C14.3238 27.0766 14.7661 28.1373 14.7661 29.2432Z",
    fill: "url(#paint23_radial_475_12217)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30.84 30.0079C31.6365 29.5413 32.2556 28.8236 32.6004 27.9673C32.9452 27.1111 32.9962 26.1646 32.7453 25.2763C32.4943 24.3879 31.9558 23.608 31.2139 23.0586C30.4721 22.5093 29.569 22.2216 28.6461 22.2406C27.7232 22.2597 26.8327 22.5845 26.1143 23.164C25.3958 23.7435 24.8899 24.5451 24.6759 25.443C24.4619 26.341 24.5519 27.2845 24.9317 28.1258C25.3116 28.9671 25.9599 29.6586 26.775 30.0919C27.1768 29.9378 27.6174 29.9168 28.032 30.0319C28.674 30.2179 29.73 30.4519 30.843 30.0079",
    fill: "url(#paint24_radial_475_12217)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.84 30.0079C31.6365 29.5413 32.2556 28.8236 32.6004 27.9673C32.9452 27.1111 32.9962 26.1646 32.7453 25.2763C32.4943 24.3879 31.9558 23.608 31.2139 23.0586C30.4721 22.5093 29.569 22.2216 28.6461 22.2406C27.7232 22.2597 26.8327 22.5845 26.1143 23.164C25.3958 23.7435 24.8899 24.5451 24.6759 25.443C24.4619 26.341 24.5519 27.2845 24.9317 28.1258C25.3116 28.9671 25.9599 29.6586 26.775 30.0919C27.1768 29.9378 27.6174 29.9168 28.032 30.0319C28.674 30.2179 29.73 30.4519 30.843 30.0079",
    fill: "url(#paint25_radial_475_12217)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30.84 30.0079C31.6365 29.5413 32.2556 28.8236 32.6004 27.9673C32.9452 27.1111 32.9962 26.1646 32.7453 25.2763C32.4943 24.3879 31.9558 23.608 31.2139 23.0586C30.4721 22.5093 29.569 22.2216 28.6461 22.2406C27.7232 22.2597 26.8327 22.5845 26.1143 23.164C25.3958 23.7435 24.8899 24.5451 24.6759 25.443C24.4619 26.341 24.5519 27.2845 24.9317 28.1258C25.3116 28.9671 25.9599 29.6586 26.775 30.0919C27.1768 29.9378 27.6174 29.9168 28.032 30.0319C28.674 30.2179 29.73 30.4519 30.843 30.0079",
    fill: "url(#paint26_radial_475_12217)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M30.84 30.0079C31.6365 29.5413 32.2556 28.8236 32.6004 27.9673C32.9452 27.1111 32.9962 26.1646 32.7453 25.2763C32.4943 24.3879 31.9558 23.608 31.2139 23.0586C30.4721 22.5093 29.569 22.2216 28.6461 22.2406C27.7232 22.2597 26.8327 22.5845 26.1143 23.164C25.3958 23.7435 24.8899 24.5451 24.6759 25.443C24.4619 26.341 24.5519 27.2845 24.9317 28.1258C25.3116 28.9671 25.9599 29.6586 26.775 30.0919C27.1768 29.9378 27.6174 29.9168 28.032 30.0319C28.674 30.2179 29.73 30.4519 30.843 30.0079",
    fill: "url(#paint27_radial_475_12217)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_475_12217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.1599 30.0079C64.3634 29.5413 63.7443 28.8236 63.3995 27.9673C63.0547 27.1111 63.0038 26.1646 63.2547 25.2763C63.5056 24.3879 64.0441 23.608 64.786 23.0586C65.5278 22.5093 66.4309 22.2216 67.3538 22.2406C68.2767 22.2597 69.1672 22.5845 69.8857 23.164C70.6042 23.7435 71.11 24.5451 71.324 25.443C71.538 26.341 71.4481 27.2845 71.0682 28.1258C70.6883 28.9671 70.04 29.6586 69.2249 30.0919C68.8232 29.9378 68.3826 29.9168 67.9679 30.0319C67.3259 30.2179 66.2729 30.4519 65.1599 30.0079Z",
    fill: "url(#paint28_radial_475_12217)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1599 30.0079C64.3634 29.5413 63.7443 28.8236 63.3995 27.9673C63.0547 27.1111 63.0038 26.1646 63.2547 25.2763C63.5056 24.3879 64.0441 23.608 64.786 23.0586C65.5278 22.5093 66.4309 22.2216 67.3538 22.2406C68.2767 22.2597 69.1672 22.5845 69.8857 23.164C70.6042 23.7435 71.11 24.5451 71.324 25.443C71.538 26.341 71.4481 27.2845 71.0682 28.1258C70.6883 28.9671 70.04 29.6586 69.2249 30.0919C68.8232 29.9378 68.3826 29.9168 67.9679 30.0319C67.3259 30.2179 66.2729 30.4519 65.1599 30.0079Z",
    fill: "url(#paint29_radial_475_12217)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_di_475_12217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.114 67.85C52.2031 67.85 55.518 64.5351 55.518 60.446C55.518 56.3569 52.2031 53.042 48.114 53.042C44.0248 53.042 40.71 56.3569 40.71 60.446C40.71 64.5351 44.0248 67.85 48.114 67.85Z",
    fill: "url(#paint30_radial_475_12217)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_475_12217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.6299 21.533C49.1489 21.473 50.4689 21.74 51.6299 23.315C52.7939 24.89 59.8679 34.97 63.2579 39.815C63.9149 40.829 65.8559 42.431 68.3669 40.706C70.8779 38.981 78.9599 33.131 82.0079 31.1",
    stroke: "url(#paint31_linear_475_12217)",
    strokeWidth: 0.075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6299 21.533C49.1489 21.473 50.4689 21.74 51.6299 23.315C52.7939 24.89 59.8679 34.97 63.2579 39.815C63.9149 40.829 65.8559 42.431 68.3669 40.706C70.8779 38.981 78.9599 33.131 82.0079 31.1",
    stroke: "url(#paint32_radial_475_12217)",
    strokeWidth: 0.075
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M47.988 21.806C50.972 21.806 53.391 19.387 53.391 16.403C53.391 13.419 50.972 11 47.988 11C45.004 11 42.585 13.419 42.585 16.403C42.585 19.387 45.004 21.806 47.988 21.806Z",
    fill: "url(#paint33_radial_475_12217)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M47.988 21.806C50.972 21.806 53.391 19.387 53.391 16.403C53.391 13.419 50.972 11 47.988 11C45.004 11 42.585 13.419 42.585 16.403C42.585 19.387 45.004 21.806 47.988 21.806Z",
    fill: "url(#paint34_radial_475_12217)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M47.988 21.806C50.972 21.806 53.391 19.387 53.391 16.403C53.391 13.419 50.972 11 47.988 11C45.004 11 42.585 13.419 42.585 16.403C42.585 19.387 45.004 21.806 47.988 21.806Z",
    fill: "url(#paint35_radial_475_12217)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M47.988 21.806C50.972 21.806 53.391 19.387 53.391 16.403C53.391 13.419 50.972 11 47.988 11C45.004 11 42.585 13.419 42.585 16.403C42.585 19.387 45.004 21.806 47.988 21.806Z",
    fill: "url(#paint36_radial_475_12217)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7659 29.2432C89.7659 30.3496 89.3264 31.4106 88.544 32.1929C87.7617 32.9752 86.7007 33.4147 85.5943 33.4147C84.488 33.4147 83.427 32.9752 82.6447 32.1929C81.8623 31.4106 81.4229 30.3496 81.4229 29.2432C81.4229 28.1373 81.8622 27.0766 82.6442 26.2946C83.4262 25.5126 84.4869 25.0732 85.5928 25.0732C86.6988 25.0732 87.7595 25.5126 88.5415 26.2946C89.3235 27.0766 89.7628 28.1373 89.7628 29.2432",
    fill: "url(#paint37_radial_475_12217)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7659 29.2432C89.7659 30.3496 89.3264 31.4106 88.544 32.1929C87.7617 32.9752 86.7007 33.4147 85.5943 33.4147C84.488 33.4147 83.427 32.9752 82.6447 32.1929C81.8623 31.4106 81.4229 30.3496 81.4229 29.2432C81.4229 28.1373 81.8622 27.0766 82.6442 26.2946C83.4262 25.5126 84.4869 25.0732 85.5928 25.0732C86.6988 25.0732 87.7595 25.5126 88.5415 26.2946C89.3235 27.0766 89.7628 28.1373 89.7628 29.2432",
    fill: "url(#paint38_radial_475_12217)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7659 29.2432C89.7659 30.3496 89.3264 31.4106 88.544 32.1929C87.7617 32.9752 86.7007 33.4147 85.5943 33.4147C84.488 33.4147 83.427 32.9752 82.6447 32.1929C81.8623 31.4106 81.4229 30.3496 81.4229 29.2432C81.4229 28.1373 81.8622 27.0766 82.6442 26.2946C83.4262 25.5126 84.4869 25.0732 85.5928 25.0732C86.6988 25.0732 87.7595 25.5126 88.5415 26.2946C89.3235 27.0766 89.7628 28.1373 89.7628 29.2432",
    fill: "url(#paint39_radial_475_12217)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7659 29.2432C89.7659 30.3496 89.3264 31.4106 88.544 32.1929C87.7617 32.9752 86.7007 33.4147 85.5943 33.4147C84.488 33.4147 83.427 32.9752 82.6447 32.1929C81.8623 31.4106 81.4229 30.3496 81.4229 29.2432C81.4229 28.1373 81.8622 27.0766 82.6442 26.2946C83.4262 25.5126 84.4869 25.0732 85.5928 25.0732C86.6988 25.0732 87.7595 25.5126 88.5415 26.2946C89.3235 27.0766 89.7628 28.1373 89.7628 29.2432",
    fill: "url(#paint40_radial_475_12217)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_475_12217",
    x: 9.175,
    y: 19.9139,
    width: 77.6471,
    height: 59.3239,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2,
    dy: -0.05
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.803922 0 0 0 0 0.580392 0 0 0 0 0.262745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_475_12217"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.2,
    dy: -0.05
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.894118 0 0 0 0 0.686275 0 0 0 0 0.301961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_475_12217",
    result: "effect2_innerShadow_475_12217"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_475_12217",
    x: 62.895,
    y: 55.5713,
    width: 8.94092,
    height: 9.73828,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.125,
    dy: 0.125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.54902 0 0 0 0 0.305882 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_475_12217"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_475_12217",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.075,
    dy: -0.075
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.984314 0 0 0 0 0.219608 0 0 0 0 0.254902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_475_12217"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_475_12217",
    x: 24.1438,
    y: 55.5713,
    width: 8.93945,
    height: 9.73828,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.125,
    dy: 0.125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.905882 0 0 0 0 0.439216 0 0 0 0 0.278431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_475_12217"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_475_12217",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.15,
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.796078 0 0 0 0 0.141176 0 0 0 0 0.223529 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_475_12217"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_475_12217",
    x: 63.0977,
    y: 22.2397,
    width: 8.33984,
    height: 8.02246,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0625
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.756863 0 0 0 0 0.619608 0 0 0 0 0.321569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_475_12217"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_di_475_12217",
    x: 39.835,
    y: 52.667,
    width: 16.0581,
    height: 16.0581,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.25,
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.937255 0 0 0 0 0.443137 0 0 0 0 0.376471 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_475_12217"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_475_12217",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.375,
    dy: -0.375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.313726 0 0 0 0 0.384314 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_475_12217"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_475_12217",
    x: 48.5505,
    y: 21.4128,
    width: 33.5533,
    height: 20.1681,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0375,
    result: "effect1_foregroundBlur_475_12217"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.136 63.2092) rotate(-103.54) scale(5.25546 6.4701)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#395DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C68A3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.7808 56.4146) rotate(108.743) scale(8.97186)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#3DB3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73F4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.2761 58.43) rotate(161.162) scale(4.20989 2.66915)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#5FBEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.9682 34.148) rotate(15.9454) scale(9.55514 23.8492)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC96E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC567"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.5932 36.209) rotate(-156.753) scale(7.24445 21.788)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#D89F3A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911,
    stopColor: "#DAA139"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.6256 39.9571) rotate(-125.455) scale(7.59606 7.79049)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#BF812A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE9333"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.7662 36.254) rotate(-23.0909) scale(6.57354 17.1251)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#E9BB61",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#E9BB61"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.6592 38.1283) rotate(-142.922) scale(10.3407 17.4452)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#C18739",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#C18739"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_475_12217",
    x1: 69.618,
    y1: 55.2079,
    x2: 16.62,
    y2: 67.5679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#FCAD6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB7547"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.399 89.0449) rotate(-69.4212) scale(33.0078 64.2438)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F67B4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F67B4E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_475_12217",
    x1: 15.843,
    y1: 66.3019,
    x2: 24,
    y2: 64.6159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2794C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E07648",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_475_12217",
    x1: 79.875,
    y1: 71.5519,
    x2: 66,
    y2: 68.3659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#FFBB5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB5B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_475_12217",
    x1: 52.314,
    y1: 80.0839,
    x2: 52.314,
    y2: 76.5199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FF6F8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A6A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.189 30.6769) rotate(113.385) scale(7.55835 6.26528)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.377,
    stopColor: "#DD9049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8BF60",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.141 31.0999) rotate(64.2172) scale(6.14276 3.35993)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#D7783D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7783D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48 19.9669) rotate(76.0566) scale(3.50158 7.66804)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.382,
    stopColor: "#D48C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB16A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.0932 62.6481) rotate(-51.5819) scale(6.94004 4.47812)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF196C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1F4A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.8752 58.9881) rotate(149.744) scale(5.20969 3.29989)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.223,
    stopColor: "#FF5873"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5873",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.4376 62.8332) rotate(-104.281) scale(5.32068 5.09436)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6196C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E42047"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.6411 59.6001) rotate(155.726) scale(2.6225 2.29709)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE536F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE536F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.9674 26.3931) rotate(135.198) scale(8.91861 9.27861)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#E7C04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9972A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.65656 33.9597) rotate(-71.331) scale(4.97877 5.39316)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.065,
    stopColor: "#DF8089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF8089",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.3011 26.5852) rotate(141.017) scale(4.22118 2.18139)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.0481 29.5102) rotate(180) scale(5.625 5.84616)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    stopColor: "#E1AD3D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9894B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.1081 23.5057) rotate(136.302) scale(8.75271 9.09681)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#E7C04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9972A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.436 23.6929) rotate(142.093) scale(4.15873 2.13041)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.734 30.7699) rotate(-76.7987) scale(3.89995 5.20139)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4A122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4A122",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.186 26.5039) rotate(180) scale(5.625 5.625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    stopColor: "#E1AD3D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9894B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.4059 24.8664) rotate(136.32) scale(7.19451 7.47738)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#F0C950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8861F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.0159 24.0679) rotate(147.14) scale(4.01786 2.05823)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFDE71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.373 58.1454) rotate(138.155) scale(8.43177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FBFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E94FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_475_12217",
    x1: 48.6329,
    y1: 20.927,
    x2: 67.6649,
    y2: 44.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD678",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.6649 42.584) rotate(-34.6679) scale(19.4918 5.22067)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    stopColor: "#FFD175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD175",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.316 13.4267) rotate(125.606) scale(10.3056 8.74971)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.376,
    stopColor: "#F3D154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC9848"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.968 21.806) rotate(-79.3129) scale(5.4977 6.53522)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E78F5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E78F5E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.25 18.209) rotate(-146.725) scale(10.765 12.8754)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#E9C251",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B49858"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.189 13.988) rotate(156.06) scale(5.94931 4.57826)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFED77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88.9685 26.3962) rotate(135.198) scale(8.91861 9.27861)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#F8CB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAA34B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.6599 33.9592) rotate(-71.3309) scale(4.97878 6.72979)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F1907C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1907C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(89.3039 26.5882) rotate(141.017) scale(4.22118 2.18139)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_475_12217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.0479 29.5102) rotate(180) scale(5.625 5.84616)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    stopColor: "#E0A444",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6924D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.b87205a42016f00637823b85c5aa49db.svg";
export { ForwardRef as ReactComponent };